import React, {  Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import { ISessionListProps } from '../../../../models/components/add-activity-exam-sessions';
import * as Actions from '../../../../store/actions/examSession';
import { IAction, IAppState } from '../../../../models/action/core';
import { connect } from 'react-redux';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('Exam Session List');
let _common: Common;

class SessionList extends React.Component<ISessionListProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    componentDidMount () {
        this.getExamSessionList();
    }

    componentDidUpdate(prevProps: ISessionListProps) {
        if (prevProps.updateActivityId !== this.props.updateActivityId) {
            this.getExamSessionList();
        }
    }

    getExamSessionList = () => {
        if (this.props.coursePageActivityId && this.props.coursePageClassId && this.props.updateActivityId) {
            this.props.dispatch(Actions.ExamSessionListGetAction(this.props.updateActivityId, this.props.coursePageActivityId, this.props.coursePageClassId, '', 'get'));
        }
    }

    getSelectedSession = (examSessionId: string) => {
        if (this.props.coursePageActivityId && this.props.coursePageClassId && examSessionId) {
            this.props.dispatch(Actions.ExamSessionSelectedGetAction(examSessionId, this.props.coursePageActivityId, this.props.coursePageClassId, '', 'get'));
        }
    }

    public render() {
        return (
            <div className="main-sidebar">
                <ul>
                    <li className="mt-0 position-relative active" style={{borderBottom:'1px solid #ccccc9'}}>
                        <div className="d-flex justify-content-between align-items-center">
                            <span style={{fontSize:'24px',fontWeight:600}}>{T.t('r_gen_exam_sessions')}</span>
                            <div className="add-session-options d-inline-flex align-items-center">
                            <Tooltip data={T.t('r_gen_new_exam_session_add')} position='top'>
                                <a className="ml-3 mr-0 lead-tooltip" onClick={this.props.triggerModal.bind(this, '', '_sessionProperties')}>
                                    <i className="material-icons " style={{fontWeight:'bold'}}>add</i>
                                </a>
                                </Tooltip>
                            </div>
                        </div>
                    </li>
                </ul>
                {this.props.sessionList && this.props.sessionList.map((session, index) => (
                    <div key={index} onClick={this.getSelectedSession.bind(this, session.examSessionId)} className="add-session-row" 
                    style={{ cursor: 'pointer', background: this.props.selectedExamSession && this.props.selectedExamSession.examSessionId === session.examSessionId ? '#d9d8d4' : '#fbfaf6' }}>
                        {/* <span>{session.activityName} ({session.programNames})</span> */}
                        <h6>{session.sessionName}</h6>
                    </div>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISessionListProps): ISessionListProps => {
    if (!state) {
        return ownProps;
    }

    const ExamSessionObject: any = state.examSession;
    const newProps: ISessionListProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        sessionList: ExamSessionObject.sessionList,
        selectedExamSession: state.examSession.selectedSession
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.examSession.sessionList === prev.examSession.sessionList &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.examSession.selectedSession === prev.examSession.selectedSession;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CSessionList = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(SessionList);

export default CSessionList;
